import React from 'react';

function DashboardSettings() {
  return <h3 className="text-xl font-semibold">Dashboard Settings</h3>;
}

export default DashboardSettings;